import appConstants from '@/constants/constants'
import router from '@/router'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import { playNewMessageSound } from '@/composables/audioHelper'
import { showMimirmanToast, showNewMessageToast, showTelegramToast, showViberToast } from '@/composables/toast'
import telegramDarkThemeSrc from '@/assets/images/contacts/telegram-dark-theme.svg'
import telegramWhiteSrc from '@/assets/images/contacts/telegram-white.svg'
import viberDarkThemeSrc from '@/assets/images/contacts/viber-dark-theme.svg'
import viberWhiteSrc from '@/assets/images/contacts/viber-white.svg'

export const processNewChatMessageByRoute = data => {
  if (
    [
      appConstants.router.chat.APP_USER_CHAT, appConstants.router.chat.APP_PATIENT_CHAT,
      appConstants.router.chat.APP_MIMIRMAN_CHAT
    ].includes(router.currentRoute.name)
  ) {
    store.commit('chat/SET_NEW_MESSAGE', data)
  } else {
    processNewChatMessage(data)
  }
}

export const processNewChatMessage = data => {
  const m = data.message
  if (m.type === 'Viber') {
    showViberToast(m.sender_full_name, m.text)
  } else if (m.type === 'Telegram') {
    showTelegramToast(m.sender_full_name, m.text)
  } else if (m.type === 'Mimirman') {
    showMimirmanToast(m.text)
  } else {
    showNewMessageToast(m.sender_full_name, m.text)
  }
  playNewMessageSound()
}

export const viberApiEnabled = () => {
  const userData = getUserData()
  return userData && userData.viber_api_enabled
}

export const telegramApiEnabled = () => {
  const userData = getUserData()
  return userData && userData.telegram_api_enabled
}

export const enabledChatMessengers = () => {
  const types = []
  if (viberApiEnabled()) {
    types.push(appConstants.chat.messengerType.VIBER)
  }
  if (telegramApiEnabled()) {
    types.push(appConstants.chat.messengerType.TELEGRAM)
  }
  return types
}

export const getTelegramIcon = () =>
  store.state.appConfig.layout.skin === 'dark' ? telegramDarkThemeSrc : telegramWhiteSrc

export const getViberIcon = () => store.state.appConfig.layout.skin === 'dark' ? viberDarkThemeSrc : viberWhiteSrc
